import { render, staticRenderFns } from "./siteConfiguration.vue?vue&type=template&id=a5fc1164&"
import script from "./siteConfiguration.vue?vue&type=script&lang=js&"
export * from "./siteConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports